export interface Event {
  [key: string]: string | Event
}
export const transformValuesToKebabCase = (obj: Event) => {
  return Object.keys(obj).reduce((acc: Event, key: string) => {
    switch (typeof obj[key]) {
      case 'string':
        acc[key] = (obj[key] as string).replace(/\s+/g, '_').toLowerCase()
        break
      case 'object':
        acc[key] = transformValuesToKebabCase(obj[key] as Event)
        break
      default:
        acc[key] = obj[key]
    }
    return acc
  }, {})
}
